import React from "react"
import SideBar from "../common/layout/sidebar.component.jsx"
import SchedulingTabs from "../common/layout/tabs/scheduling.component.jsx"
import GenericListing from "../common/listing/generic-listing/GenericListing"
import { ObjectType } from "../state/listing/generic-listing/index"


const AppointmentListing = () => {
    SideBar.activateMenu("schedulingpage")

    return (
        <>
            <SchedulingTabs />
            <GenericListing
                objectType={ObjectType.CALENDAR_EVENTS}
            />
        </>
    )
}
export default AppointmentListing


// WEBPACK FOOTER //
// ./src/scheduling-page/AppointmentListing.tsx